export default __webpack_public_path__ + "static/media/team.4e73fd87.svg";